"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenerEventTypes = exports.CloseReasonType = void 0;
// TODO 3 out of 4 items are the same as in `CloseReason` enum. Maybe there is sense kinda extend this enum from `CloseReason`?
var CloseReasonType;
(function (CloseReasonType) {
    CloseReasonType["FinishedFlow"] = "finished-flow";
    CloseReasonType["Canceled"] = "canceled";
    CloseReasonType["CanceledDueToError"] = "canceled-due-to-error";
    CloseReasonType["ClosedByOpener"] = "closed-by-opener";
})(CloseReasonType = exports.CloseReasonType || (exports.CloseReasonType = {}));
var OpenerEventTypes;
(function (OpenerEventTypes) {
    OpenerEventTypes["Opened"] = "opened";
    OpenerEventTypes["Closed"] = "closed";
    OpenerEventTypes["Error"] = "error";
})(OpenerEventTypes = exports.OpenerEventTypes || (exports.OpenerEventTypes = {}));
//# sourceMappingURL=constants.js.map